export default __webpack_public_path__ + "static/media/Software-Gestao-Projetos.d74cfe85.png";